
export const _onSubmit = () => {

	const optionsOne = document.querySelector(".options-when");
	const optionsTwo = document.querySelector(".options-where");
	const optionsMessageOne = document.querySelector(".c-stage-form__options-message-1");
	const optionsMessageTwo = document.querySelector(".c-stage-form__options-message-2");
	const form = document.querySelector("#contact_form");
	const contentMessage = document.querySelector(".c-stage-form__content-message");
	const nameMessage = document.querySelector(".c-stage-form__name-message");
	const emailMessage = document.querySelector(".c-stage-form__email-message");
	const formModal = document.querySelector("#form-modal");
	const cardTitle = document.querySelector(".c-form-modal-card__title");
	const spinner = document.querySelectorAll(".c-stage-form__spinner");
	const checkedValues = document.querySelectorAll(".c-stage-form__option-checkbox-label");
	const list = document.querySelector(".c-form-modal-card__list");
	const returnTo = document.querySelector(".return-to");

	// Get values from localStorage
	const storageValues = JSON.parse(localStorage.getItem("values"));
	const storageLink = localStorage.getItem("link");
	const storageTitle = localStorage.getItem("title");
	const pathName = document.location.pathname;
	const searchName = document.location.search;

	if ( storageValues && storageLink && storageTitle ) {

		if ( storageLink === pathName + searchName ) {
			cardTitle.innerText = storageTitle;

			if ( storageTitle.includes("Rush") ) {
				let rushValue = storageValues.shift();
				const rushText = document.createElement("li");
				rushText.classList.add("c-form-modal-card__text", "time");
				rushText.innerText = rushValue;
				list.appendChild(rushText);
			}

			for ( let i = 0; i < storageValues.length; i++ ) {
				const newElement = document.createElement("li");
				newElement.classList.add("c-form-modal-card__text", "positive");
				newElement.innerText = storageValues[i];
				list.appendChild(newElement);
			}

			setTimeout(() => {
				formModal.classList.add("is-visible");
			}, 1000)
		}
	}

	if ( optionsOne ) {
		optionsOne.addEventListener('change', () => {
			optionsOne.value === "Within 4 weeks" ? optionsMessageOne.classList.add("is-active") : optionsMessageOne.classList.remove("is-active")
		})
	}

	if ( optionsTwo ) {
		optionsTwo.addEventListener('change', () => {
			optionsTwo.value != "California" ? optionsMessageTwo.classList.add("is-active") : optionsMessageTwo.classList.remove("is-active");
		})
	}

	if ( form ) {

		form.addEventListener('submit', (e) => {
			e.preventDefault();

			const selectedValues = [];
			checkedValues.forEach(item => {
				if ( item.classList.contains("checked") ) {

					let itemValue = item.textContent.trim()
					selectedValues.push(itemValue);
				}
			})

			selectedValues.unshift( optionsOne.value );

			spinner.forEach(element => {
				element.classList.add("is-active");

				setTimeout(() => {
					element.classList.remove("is-active");

					if ( form.elements['contact[name]'].value === "" && form.elements['contact[email]'].value === "" )  {
						contentMessage.classList.add("is-active");
						nameMessage.classList.add("is-active");
						emailMessage.classList.add("is-active");
						form.elements['contact[name]'].classList.add("is-active");
						form.elements['contact[email]'].classList.add("is-active");
						return

					} else if ( form.elements['contact[email]'].value === "" ) {
						nameMessage.classList.remove("is-active");
						form.elements['contact[name]'].classList.remove("is-active");
						contentMessage.classList.add("is-active");
						emailMessage.classList.add("is-active");
						form.elements['contact[email]'].classList.add("is-active");
						return

					} else if ( form.elements['contact[name]'].value === "" ) {
						emailMessage.classList.remove("is-active");
						form.elements['contact[email]'].classList.remove("is-active");
						contentMessage.classList.add("is-active");
						nameMessage.classList.add("is-active");
						form.elements['contact[name]'].classList.add("is-active");
						return
					}

					fetch(window.Shopify.routes.root + `search/suggest.json?q=${ selectedValues.join() }&resources[type]=product&resources[options][fields]=tag&resources[options][unavailable_products]=show`)
					.then((response) => response.json()
					)
					.then((suggestions) => {
					  const productSuggestions = suggestions.resources.results.products;
						let result;
						let points = 0;

						for ( let i = 0; i < productSuggestions.length; i++ ) {
								points = 0;
							for ( let j = 0; j < selectedValues.length; j++ ) {
								if (productSuggestions[i].tags.includes(selectedValues[j])) {
									++points;
								}
							}

							if ( selectedValues.length ==  points) {
								result = productSuggestions[i];
								break;
							}
						}

						localStorage.setItem("values", JSON.stringify(selectedValues));
						localStorage.setItem("link", result.url);
						localStorage.setItem("title", result.title);

						returnTo.value = result.url;
						form.submit();
					}
				  );
				}, 1000);
			});
		})
	}
}
